/**
 * Cuál es la creación de AL LADO cuando el visor prestado navega con las flechas —
 * ADR-2026-10-08-las-flechas-del-visor-siguen-a-la-columna.
 *
 * El visor arma su propia lista (`filteredImages`: las creaciones de la empresa por
 * `created_at`), pero quien lo presta —la columna de resultados— dibuja otro orden: las
 * tandas de la sesión arriba, en el orden en que se LANZARON, y después el historial.
 * Cuando dos tandas terminan en distinto orden del que se pidieron, o una tanda de varias
 * imágenes se carga desordenada, los dos órdenes se cruzan y "siguiente" saltea la card
 * que el usuario tiene al lado. Acá manda el orden que el usuario ve.
 *
 * Pura: el visor decide después cómo conseguir la fila del id (de su lista, o de la
 * columna con `filaDe`).
 */
export type VecinaEnElOrden =
  /** La que está al lado en el orden de quien presta el visor. */
  | { tipo: 'id'; id: string }
  /** Sin orden, la abierta no está en él, o se llegó al final: sigue la lista del visor. */
  | { tipo: 'lista' }
  /** Es la primera y se pidió la anterior: no hay nada antes de la primera card. */
  | { tipo: 'nada' };

export function vecinaEnElOrden(
  orden: readonly string[] | undefined,
  actualId: string,
  direccion: 1 | -1,
): VecinaEnElOrden {
  if (!orden || orden.length === 0) return { tipo: 'lista' };
  const i = orden.indexOf(actualId);
  if (i === -1) return { tipo: 'lista' };
  const j = i + direccion;
  if (j < 0) return { tipo: 'nada' };
  // Después de la última card de la columna sigue el historial más viejo, que es lo que
  // la columna también traería al scrollear: la lista del visor ya está en ese orden.
  if (j >= orden.length) return { tipo: 'lista' };
  return { tipo: 'id', id: orden[j] };
}
